import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'status',
      type: 'select',
      label: '状态',
      placeholder: '请选择状态',
      filterable: true,
      options: [
        {title: '已接通', value: 1},
        {title: '未接通', value: 2},
        {title: '意向', value: 3},
        {title: '加个微', value: 4},
        {title: '加企微', value: 5},
        {title: '已成交', value: 6}
      ]
    }
  ],
  colLayout: 24
}
